export const MoveStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 'fit-content',
    gap: '5px',
    borderRadius: '10px',
    padding: '10px',
    backgroundColor: '#14A06F'
}
export const ListMove = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '5px'
}